// App
export const APP_SESSION_INFO_SET = 'APP_SESSION_INFO_SET';

// Nav
export const NAV_SET_BREADCRUMBS = 'NAV_SET_BREADCRUMBS';

// Xml Job overview
export const XML_JOBS_OVERVIEW_PENDING = 'XML_JOBS_OVERVIEW_PENDING';
export const XML_JOBS_OVERVIEW_SUCCESS = 'XML_JOBS_OVERVIEW_SUCCESS';
export const XML_JOBS_OVERVIEW_FAILURE = 'XML_JOBS_OVERVIEW_FAILURE';
export const XML_JOBS_OVERVIEW_NO_CONTENT = 'XML_JOBS_OVERVIEW_NO_CONTENT';

// Xml Channel status
export const XML_CHANNEL_STATUS_PENDING = 'XML_CHANNEL_STATUS_PENDING';
export const XML_CHANNEL_STATUS_SUCCESS = 'XML_CHANNEL_STATUS_SUCCESS';
export const XML_CHANNEL_STATUS_FAILURE = 'XML_CHANNEL_STATUS_FAILURE';
export const XML_CHANNEL_STATUS_NO_CONTENT = 'XML_CHANNEL_STATUS_NO_CONTENT';

// Xml Channel Activate Latest Job
export const XML_JOB_ACTIVATE_PENDING = 'XML_JOB_ACTIVATE_PENDING';
export const XML_JOB_ACTIVATE_SUCCESS = 'XML_JOB_ACTIVATE_SUCCESS';
export const XML_JOB_ACTIVATE_FAILURE = 'XML_JOB_ACTIVATE_FAILURE';

// Xml Channel Job list
export const XML_JOB_LIST_SET_XML_CHANNEL = 'XML_JOB_LIST_SET_XML_CHANNEL';
export const XML_JOB_LIST_PENDING = 'XML_JOB_LIST_PENDING';
export const XML_JOB_LIST_SUCCESS = 'XML_JOB_LIST_SUCCESS';
export const XML_JOB_LIST_FAILURE = 'XML_JOB_LIST_FAILURE';
export const XML_JOB_LIST_NO_CONTENT = 'XML_JOB_LIST_NO_CONTENT';

// Filter
export const XML_CHANNEL_FILTER_SEARCH = 'XML_CHANNEL_FILTER_SEARCH';
export const XML_CHANNEL_FILTER_SYSTEM = 'XML_CHANNEL_FILTER_SYSTEM';
export const XML_CHANNEL_FILTER_STATUS = 'XML_CHANNEL_FILTER_STATUS';

// Request initiate setup
export const REQUEST_INITIATE_SETUP_PENDING = 'REQUEST_INITIATE_SETUP';
export const REQUEST_INITIATE_SETUP_SUCCESS = 'REQUEST_INITIATE_SETUP_SUCCESS';
export const REQUEST_INITIATE_SETUP_FAILURE = 'REQUEST_INITIATE_SETUP_FAILURE';

// Requests types
export const REQUEST_TYPES_LIST_PENDING = 'REQUEST_TYPES_LIST_PENDING';
export const REQUEST_TYPES_LIST_SUCCESS = 'REQUEST_TYPES_LIST_SUCCESS';
export const REQUEST_TYPES_LIST_FAILURE = 'REQUEST_TYPES_LIST_FAILURE';
export const REQUEST_TYPES_NO_CONTENT = 'REQUEST_TYPES_LIST_NO_CONTENT';

// Requests status
export const REQUESTS_CHANNEL_LIST_PENDING = 'REQUESTS_CHANNEL_LIST_PENDING';
export const REQUESTS_CHANNEL_LIST_SUCCESS = 'REQUESTS_CHANNEL_LIST_SUCCESS';
export const REQUESTS_CHANNEL_LIST_FAILURE = 'REQUESTS_CHANNEL_LIST_FAILURE';
export const REQUESTS_CHANNEL_LIST_NO_CONTENT = 'REQUESTS_CHANNEL_LIST_NO_CONTENT';

// Requests list
export const REQUESTS_SET_REQUEST = 'REQUESTS_SET_REQUEST';
export const REQUESTS_RESET_REQUEST = 'REQUESTS_RESET_REQUEST';
export const REQUESTS_LIST_PENDING = 'REQUESTS_LIST_PENDING';
export const REQUESTS_LIST_SUCCESS = 'REQUESTS_LIST_SUCCESS';
export const REQUESTS_LIST_FAILURE = 'REQUESTS_LIST_FAILURE';
export const REQUESTS_LIST_NO_CONTENT = 'REQUESTS_LIST_NO_CONTENT';

// Requests filter
export const REQUESTS_FILTER_SEARCH = 'REQUESTS_FILTER_SEARCH';

// Request list pagination
export const REQUESTS_SET_PAGINATION_INDEX = 'REQUESTS_SET_PAGINATION_INDEX';
export const REQUESTS_UPDATE_PAGINATION_INDEX = 'REQUESTS_UPDATE_PAGINATION_INDEX';
export const REQUESTS_RESET_PAGINATION_INDEX = 'REQUESTS_RESET_PAGINATION_INDEX';

// Request log files list
export const REQUEST_LOG_FILES_LIST_PENDING = 'REQUESTS_LOG_FILES_LIST_PENDING';
export const REQUEST_LOG_FILES_LIST_SUCCESS = 'REQUESTS_LOG_FILES_LIST_SUCCESS';
export const REQUEST_LOG_FILES_LIST_FAILURE = 'REQUESTS_LOG_FILES_LIST_FAILURE';
export const REQUEST_LOG_FILES_LIST_NO_CONTENT = 'REQUESTS_LOG_FILES_LIST_NO_CONTENT';

// Requests Domains list
export const REQUESTS_DOMAINS_LIST_PENDING = 'REQUESTS_DOMAINS_LIST_PENDING';
export const REQUESTS_DOMAINS_LIST_SUCCESS = 'REQUESTS_DOMAINS_LIST_SUCCESS';
export const REQUESTS_DOMAINS_LIST_FAILURE = 'REQUESTS_DOMAINS_LIST_FAILURE';
export const REQUESTS_DOMAINS_LIST_NO_CONTENT = 'REQUESTS_DOMAINS_LIST_NO_CONTENT';

// Prices channel list
export const PRICES_CHANNEL_LIST_PENDING = 'PRICES_CHANNEL_LIST_PENDING';
export const PRICES_CHANNEL_LIST_SUCCESS = 'PRICES_CHANNEL_LIST_SUCCESS';
export const PRICES_CHANNEL_LIST_FAILURE = 'PRICES_CHANNEL_LIST_FAILURE';
export const PRICES_CHANNEL_LIST_NO_CONTENT = 'PRICES_CHANNEL_LIST_NO_CONTENT';

// Prices job list
export const PRICES_JOB_LIST_PENDING = 'PRICES_JOB_LIST_PENDING';
export const PRICES_JOB_LIST_SUCCESS = 'PRICES_JOB_LIST_SUCCESS';
export const PRICES_JOB_LIST_FAILURE = 'PRICES_JOB_LIST_FAILURE';
export const PRICES_JOB_LIST_NO_CONTENT = 'PRICES_JOB_LIST_NO_CONTENT';

// Prices Channel prices list
export const PRICES_CHANNEL_PRODUCTS_LIST_PENDING = 'PRICES_CHANNEL_PRODUCTS_LIST_PENDING';
export const PRICES_CHANNEL_PRODUCTS_LIST_SUCCESS = 'PRICES_CHANNEL_PRODUCTS_LIST_SUCCESS';
export const PRICES_CHANNEL_PRODUCTS_LIST_FAILURE = 'PRICES_CHANNEL_PRODUCTS_LIST_FAILURE';
export const PRICES_CHANNEL_PRODUCTS_LIST_NO_CONTENT = 'PRICES_CHANNEL_PRODUCTS_LIST_NO_CONTENT';

// Prices import list
export const PRICES_IMPORT_LIST_PENDING = 'PRICES_IMPORT_LIST_PENDING';
export const PRICES_IMPORT_LIST_SUCCESS = 'PRICES_IMPORT_LIST_SUCCESS';
export const PRICES_IMPORT_LIST_FAILURE = 'PRICES_IMPORT_LIST_FAILURE';
export const PRICES_IMPORT_LIST_NO_CONTENT = 'PRICES_IMPORT_LIST_NO_CONTENT';

// Prices PUSH list
export const PRICES_PUSH_LIST_PENDING = 'PRICES_PUSH_LIST_PENDING';
export const PRICES_PUSH_LIST_SUCCESS = 'PRICES_PUSH_LIST_SUCCESS';
export const PRICES_PUSH_LIST_FAILURE = 'PRICES_PUSH_LIST_FAILURE';
export const PRICES_PUSH_LIST_NO_CONTENT = 'PRICES_PUSH_LIST_NO_CONTENT';

// Prices clear list
export const PRICES_LIST_RESET = 'PRICES_LIST_RESET';

// Prices set/clear channel
export const PRICES_SET_CHANNEL = 'PRICES_SET_CHANNEL';
export const PRICES_CLEAR_CHANNEL = 'PRICES_CLEAR_CHANNEL';

// Prices set/remove job
export const PRICES_SET_TYPE = 'PRICES_SET_TYPE';
export const PRICES_CLEAR_TYPE = 'PRICES_CLEAR_TYPE';

// Prices clear state(clears selectedType & selectedChannel)
export const PRICES_CLEAR_STATE = 'PRICES_CLEAR_STATE';

// Prices list pagination
export const PRICES_SET_PAGINATION_INDEX = 'PRICES_SET_PAGINATION_INDEX';
export const PRICES_UPDATE_PAGINATION_INDEX = 'PRICES_UPDATE_PAGINATION_INDEX';
export const PRICES_RESET_PAGINATION_INDEX = 'PRICES_RESET_PAGINATION_INDEX';
export const PRICES_LOAD_NEW_PAGE = 'PRICES_LOAD_NEW_PAGE';



// WEBPACK FOOTER //
// ./src/store/modules/constants.js